export { default } from './EditScoreButton'
